export default "__VITE_ASSET__4n4argGA__"